module.exports = __webpack_public_path__ + "ntenant_market_icon.svg";